export default __webpack_public_path__ + "images/Y4.dc36ce7.png";